import React from "react";
import { SensorKitModel } from "@/sensorKits/sensorKit";
import { useSensorKitConfigs } from "@/sensorKitConfigs/api";
import { MultiSelect, OptionType } from "@/components/ui/multi-select";

interface VersionMultiSelectProps {
  model: SensorKitModel;
  selected: string[];
  onChange: (versions: string[]) => void;
}

export const VersionMultiSelect = ({ model, selected, onChange }: VersionMultiSelectProps) => {
  const { data: configs } = useSensorKitConfigs({ model });

  // Extract unique versions from configs
  const versions = [...new Set(configs.results.map(config => config.version))].sort();

  const options: OptionType[] = versions.map((version) => ({
    label: version,
    value: version,
  }));

  const selectedOptions: OptionType[] = selected.map((version) => ({
    label: version,
    value: version,
  }));

  return (
    <MultiSelect
      className="w-[180px]"
      placeholder="Filter by Version"
      options={options}
      selected={selectedOptions}
      onChange={(selectedOptions) => {
        onChange(selectedOptions.map(option => option.value as string));
      }}
      customSelectedText={selected.length === 0 ? undefined : `${selected.length} version${selected.length !== 1 ? 's' : ''}`}
      showSelectAllAndNone={true}
    />
  );
};
